import { Component, OnInit, ViewChild } from '@angular/core';
import { SiteListAccessService } from '../site-list-access.service';
import { PlantingSiteDto } from '../../../../models/trofaco/plantingSiteDto';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { PageChangedEvent, PaginationComponent } from 'ngx-bootstrap';

import {
    debounceTime,
    distinctUntilChanged,
    filter,
    map, skip,
    startWith,
    takeUntil
} from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { BaseComponent } from '../../../core/components/bases/base-component';

@Component({
    selector: 'app-list-grid',
    templateUrl: './list-grid.component.html',
    styleUrls: ['./list-grid.component.css']
})
export class ListGridComponent extends BaseComponent implements OnInit {
    @ViewChild(PaginationComponent, {static: true}) pagination: PaginationComponent;
    sites: PlantingSiteDto[] = [];
    sitesPage: PlantingSiteDto[] = [];
    pageNo: number = 0;

    readonly pageSizeSelectAbleOptions = [12, 24, 48, 96];
    pageSize = this.pageSizeSelectAbleOptions[0];

    constructor(private siteAccess: SiteListAccessService, private router: Router, private route: ActivatedRoute) {
        super();
    }

    ngOnInit() {
        this.siteAccess.filteredSites$.pipe(
            skip(1),
            takeUntil(this.onDestroy$)
        ).subscribe(() => {
            this.pagination.selectPage(1);
        });

        let page$ = this.pagination.pageChanged.pipe(
            map((event: PageChangedEvent) => event.page),
            startWith(1),
            distinctUntilChanged()
        );

        combineLatest([page$, this.siteAccess.filteredSites$])
            .pipe(
                filter(([page, sites]) => this.pageNo !== page || this.sites !== sites),
                debounceTime(0),
                takeUntil(this.onDestroy$)
            )
            .subscribe(([page, sites]) => {
                this.applyToSites(page, this.pageSize, sites);
            });

        this.route.queryParams.pipe(
            map(value => +(value.page || '1')),
            filter(page => page !== this.pageNo),
            distinctUntilChanged(),
        ).subscribe(page => {
            this.pagination.selectPage(page);
        });

        this.route.queryParams.pipe(
            map(value => { return { page: +(value.page || '1'), pageSize: +(value.pageSize || '12') }
            }),
            filter(value => value.page !== this.pageNo),
            distinctUntilChanged(),
        ).subscribe(value => {            
            this.pageSize = value.pageSize;
            this.applyToSites(value.page, value.pageSize, this.sites)
        });
        
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
    }

    onUpdatePageSize(pageSize: number){
        this.pagination.selectPage(1);
        this.pageSize = pageSize;
        let forcePageChanged = true;
        this.applyToSites(1, this.pageSize, this.sites, forcePageChanged);
    }

    private applyToSites(page: number, pageSize: number, sites: PlantingSiteDto[], pageChanged = true){
        if (!pageChanged)
            pageChanged = page !== this.pageNo;
        
        this.sites = sites;
        this.pageNo = page;
        let start = +pageSize * (this.pageNo - 1);
        let end = +pageSize * this.pageNo;
        this.sitesPage = sites.slice(start, end);
        if (!pageChanged) return;

        let params = {...this.route.snapshot.queryParams};
        params.page = this.pageNo;
        params.pageSize = +pageSize;
        if (params.page === 1) delete params.page;
        if (params.pageSize === 12) delete params.pageSize;

        this.router.navigate(['.'], {queryParams: params, relativeTo: this.route});
    }
}
